import { Box, CircularProgress, Typography } from '@mui/material'

export default function Loading() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '50%',
        margin: '0 auto',
        height: '80vh',
      }}
    >
      <Box
        sx={{
          mt: 4,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontSize: '24px', color: '#1C3045', alignContent: 'center' }}
        >
          <CircularProgress sx={{ color: '#1C3045' }} size={20} /> Loading...
        </Typography>
      </Box>
    </Box>
  )
}
